import { Autocomplete, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { find } from 'lodash';

// Components
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import PaperSelect from 'src/components/common/PaperSelect';
import { getFormItemError, renderFormItemError } from 'src/utils/helpers/renderFormItemError';
import { RELATIONSHIP_CONTRIBUTE_DATA } from 'src/features/Contributions/config';

const FormItemRelationContribution = () => {
  const formik = useFormikContext<ExpectedAny>();

  const getRelation = (relationship: string) => {
    const relationItem = find(RELATIONSHIP_CONTRIBUTE_DATA, (o) => o.value === relationship);
    if (!relationItem) {
      return {
        value: '',
        label: '',
      };
    }
    return relationItem;
  };

  return (
    <Autocomplete
      id="relationship_to_data"
      defaultValue={getRelation(formik.values.relationship_to_data)}
      size="small"
      fullWidth
      onBlur={formik.handleBlur}
      getOptionKey={(option) => option.optionLabel}
      options={getArrayDefault(RELATIONSHIP_CONTRIBUTE_DATA)}
      PaperComponent={PaperSelect}
      onChange={(_, value) => {
        formik.setFieldValue('relationship_to_data', value.value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={Boolean(getFormItemError('relationship_to_data', formik))}
          helperText={renderFormItemError(getFormItemError('relationship_to_data', formik))}
          id="relationship_to_data"
          name="relationship_to_data"
          placeholder="Search"
          InputLabelProps={{ required: true }}
          label={<span>Filter By Relationship to Data</span>}
        />
      )}
    />
  );
};

export default FormItemRelationContribution;
